// extracted by mini-css-extract-plugin
export default {"app":"app__Wav11eKk"};